// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1GFap","radioRow":"SimpleQuestionBuilderModal_radioRow__1FzeG"};